// extracted by mini-css-extract-plugin
export var pillWrapper = "_od-0";
export var showOverflow = "_od-1";